export default "__VITE_PUBLIC_ASSET__84daee0d__"